import useTheme from "@material-ui/core/styles/useTheme";

import { Status, Wrapper } from "@googlemaps/react-wrapper";
import React from "react";
import "./animation.css";
import formatSalary from "../../core/utils/renderSalary";
import { DatCvType } from "./Curricullum";
import { DirectionsCar, PedalBike, TwoWheeler } from "@material-ui/icons";
import { useFunctions } from "../../core/contexts/FunctionsProvider";
import compareInstrucaoCan from "../../core/utils/compareInstrucaoCan";
import compareEstcicil from "../../core/utils/compareEstcivil";

const CanInfo = ({ dataCv, id }: { dataCv: DatCvType | any; id: number }) => {
  const { intrucaoSys, populateEstCivil } = useFunctions();
  return (
    <>
      <div style={{ width: "100%", float: "left", display: "table" }}>
        Nome: <b>{dataCv?.pessoal_nome}</b> -{" "}
        <b>
          <mark>{id}</mark>
        </b>
        <br />
      </div>
      <div style={{ width: "100%", display: "table" }}>
        <div style={{ width: "33.33%", float: "left", display: "table" }}>
          Idade: <b>{dataCv?.idade}</b>
          <br />
        </div>
        <div style={{ width: "33.33%", float: "left" }}>
          Sexo: <b>{dataCv?.pessoal_sexo == "M" ? "Masculino" : "Feminino"}</b>
          <br />
        </div>
        <div style={{ width: "33.33%", float: "left" }}>
          Estado Civil:{" "}
          <b>
            {compareEstcicil(
              Number(dataCv?.pessoal_codestcivil),
              populateEstCivil
            )?.estcivil_descricao || "Não informado"}
          </b>
          <br />
        </div>
      </div>
      <div style={{ width: "100%", display: "table" }}>
        <div style={{ width: "33.33%", float: "left" }}>
          Bairro: <b>{dataCv?.pessoal_bairro}</b>
          <br />
        </div>
        <div style={{ width: "33.33%", float: "left" }}>
          Cidade: <b>{dataCv?.pessoal_cidade}</b>
          <br />
        </div>
        <div style={{ width: "33.33%", float: "left" }}>
          UF: <b>{dataCv?.pessoal_uf}</b>
          <br />
        </div>
      </div>
      <div style={{ width: "100%", display: "table" }}>
        <div style={{ width: "33.33%", float: "left" }}>
          Pretensão: <b>{formatSalary(dataCv?.pessoal_salario)}</b>
          <br />
        </div>
        <div style={{ width: "33.33%", float: "left" }}>
          Possui Filho(s):{" "}
          <b>
            {dataCv?.pessoal_filhos ? "Sim " + dataCv?.pessoal_filhos : "Não"}
          </b>
          <br />
        </div>
        <div style={{ width: "33.33%", float: "left" }}>
          Possui Deficiência:{" "}
          <b>
            {dataCv?.pessoal_dfisico == 1 ||
            Boolean(dataCv?.pessoal_dfisico) === true
              ? "Sim"
              : "Não"}
          </b>
          <br />
        </div>
      </div>
      <div style={{ width: "100%", display: "table" }}>
        <div style={{ width: "33.33%", float: "left" }}>
          CNH:{" "}
          <b>
            {dataCv?.pessoal_cnh ? "Sim - " + dataCv?.pessoal_tpcnh : "Não"}
          </b>
          <br />
        </div>
        <div style={{ width: "33.33%", float: "left" }}>
          Escolaridade:{" "}
          <b>
            {compareInstrucaoCan(dataCv?.pessoal_codinstrucao, intrucaoSys)}
          </b>
          <br />
        </div>
        <br />
      </div>
    </>
  );
};

export default CanInfo;
